import React, { Component } from 'react';
import { Modal, Header, Button, Tab } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { ReactHeight } from 'react-height';
import { get } from 'lodash';

import { FieldEnum } from 'Common/FieldEnum';
import {
  getServingNumber,
  clearServingNumber,
  saveStudentInfoAction,
  getStudentInfoAction,
  setSelectedTab,
} from '../state/actions';
import { updateChargePermissions } from '../state/chargeDefaults/actions';

import { getIsDirty } from 'Common/Selectors/DirtySelector';
import StudentInfo from './StudentInfo';
import StudentContactInfo from './StudentContactInfo';
import ChargePermission from './ChargePermission';
import {
  StudentInfoInitialValues,
  StudentContactInfoInitialValues,
  StudentInfoSubmitObject,
  StudentContactInfoSubmitObj,
  chargePermissionInitialValues,
  chargePermissionSubmitObj,
} from '../helpers/AccountSetupObjects';
import { tabEnum } from '../helpers/AccountSetupConstants';
import { createToast, toastType } from 'Common/ToastHelper';
import { ACCOUNT_SETUP_FORM_NAME } from 'Common/FormEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import { AlternateProvisionTypeEnum } from 'Common/Constants/Enumeration/AlternateProvisionTypeEnum';
import { getSitesAction } from 'State/sites/actions';
import { getSites } from 'State/sites/selectors';

export class StudentEditModalContainer extends Component {
  state = {
    height: 0,
    studentImage: null,
    deleteImage: false,
  };

  // This is never called
  componentWillUnmount() {
    this.setState({ height: 0 });
  }

  componentDidMount () {
    this.props.getSitesAction();
  }

  componentDidUpdate(prevProps) {
    if (this.props.formValues && prevProps.formValues) {
      const newSiteId = this.props.formValues.siteId;
      const prevSiteId = prevProps.formValues.siteId;
      const { isNewStudent } = this.props;

      if (newSiteId !== prevSiteId && (isNewStudent || prevSiteId.length > 0)) {
        this.props.updateChargePermissions(
          newSiteId,
          prevSiteId,
          this.props.isNewStudent
        );
      }
    }

    if (!this.props.studentInfoLoading && prevProps.studentInfoLoading) {
      this.props.resetDirty();
      this.setState({ studentImage: null, deleteImage: false });
    }
  }

  newStudentDetails = (status) => {
    const { rowIndex } = this.props;
    this.props.showNewDataDirtyConfirm({
      PageNumber: status === 'next' ? rowIndex + 1 : rowIndex - 1,
      PageSize: 1,
    });
    this.props.clearServingNumber();
  };

  setContainerHeight = (height) => {
    if (this.state.height <= height) {
      this.setState({ height: height });
    }
  };

  handleInfoSubmit = (values) => {
    return StudentInfoSubmitObject(values);
  };

  handleContactInfoSubmit = (values) => {
    return StudentContactInfoSubmitObj(values);
  };

  handleChargePermissionSubmit = (values) => {
    return chargePermissionSubmitObj(values);
  };

  saveForm = (isNew) => {
    const {
      setSelectedTab,
      saveStudentInfoAction,
      studentSeedData,
      siteId,
    } = this.props;
    if (this.studentInfoForm.invalid) {
      this.studentInfoForm.submit();
      setSelectedTab(tabEnum.STUDENT_INFO);
    } else if (this.studentContactInfoForm.invalid) {
      this.studentContactInfoForm.submit();
      setSelectedTab(tabEnum.STUDENT_CONTACT_INFO);
    } else if (this.chargePermissionForm.invalid) {
      this.chargePermissionForm.submit();
      setSelectedTab(tabEnum.CHARGE_PERMISSION);
    } else {
      const infoValues = this.studentInfoForm.submit();
      const contactValues = this.studentContactInfoForm.submit();
      const chargeValues = this.chargePermissionForm.submit();

      saveStudentInfoAction(
        {
          ...studentSeedData.Result,
          ...infoValues,
          ...contactValues,
          ...chargeValues,
          TotalPages: studentSeedData.TotalPages,
          TotalRowCount: studentSeedData.TotalRowCount,
        },
        this.state.studentImage,
        this.state.deleteImage,
        siteId.length > 0
      );
    }
  };

  renderButton = (isNew) => {
    const {
      saving,
      studentSeedData,
      isReadOnly,
      rowIndex,
      isDirty,
      studentInfoLoading,
    } = this.props;
    return (
      <div>
        {!isNew && (
          <Button
            inverted
            color="orange"
            size="big"
            content="Previous"
            disabled={rowIndex === 1 || saving || studentInfoLoading}
            onClick={() => {
              this.newStudentDetails('previous');
            }}
          />
        )}
        {!isNew && (
          <Button
            inverted
            color="orange"
            size="big"
            content="Next"
            disabled={
              (studentSeedData && studentSeedData.TotalRowCount === rowIndex) ||
              saving ||
              studentInfoLoading
            }
            onClick={() => {
              this.newStudentDetails('next');
            }}
          />
        )}
        <Button
          positive
          inverted
          tabIndex={15}
          color="orange"
          size="big"
          content="Save"
          disabled={isReadOnly || saving || !isDirty}
          onClick={() => this.saveForm(isNew)}
          loading={saving}
        />
      </div>
    );
  };

  onTabChange = (e, { activeIndex }) => {
    const { formValues, isNewStudent } = this.props;

    if (
      isNewStudent &&
      activeIndex === tabEnum.CHARGE_PERMISSION &&
      (!formValues.siteId ||
        formValues.siteId === 'ALL' ||
        formValues.siteId.length === 0)
    ) {
      e.preventDefault();
      createToast(
        toastType.error,
        'Error',
        'A Site is required to set Charge Permissions',
        true
      );
    } else {
      this.props.setSelectedTab(activeIndex);
    }
  };

  render() {
    const {
      studentSeedData,
      showEditModal,
      onClose,
      languages,
      grades,
      studentInfo,
      isReadOnly,
      siteId,
      isNewStudent,
      pictureError,
      sitesData,
    } = this.props;

    const studentSiteId = get(studentSeedData, 'Result.SiteId', siteId);
    const isCEPOrProvision2Site =
      (sitesData || []).filter(
        (v) =>
          v.Id === studentSiteId &&
          (v.AlternateProvisionTypeId === AlternateProvisionTypeEnum.CEP ||
            v.AlternateProvisionTypeId ===
              AlternateProvisionTypeEnum.Provision2_Base ||
            v.AlternateProvisionTypeId ===
              AlternateProvisionTypeEnum.Provision2_Non_Base ||
            v.AlternateProvisionTypeId ===
              AlternateProvisionTypeEnum.Prov2_Non_Base_Breakfast_Only)
      ).length === 1;

    let panes = [
      {
        menuItem: 'Student Info',
        pane: (
          <Tab.Pane attached={false} key="studentInfo">
            <StudentInfo
              ref={(instance) => {
                this.studentInfoForm = instance;
              }}
              initialValues={
                studentSeedData && studentSeedData.Result
                  ? StudentInfoInitialValues(
                      studentSeedData.Result,
                      isNewStudent
                    )
                  : {
                      [FieldEnum.StatusCurrent]: '4',
                      [FieldEnum.Purchases]: (0).toFixed(2),
                      [FieldEnum.Balance]: (0).toFixed(2),
                      [FieldEnum.Payments]: (0).toFixed(2),
                      [FieldEnum.Grade]: '00',
                      [FieldEnum.LanguageId]: 1,
                      [FieldEnum.SiteId]:
                        isNewStudent && siteId.toUpperCase() !== 'ALL'
                          ? siteId
                          : '',
                      [FieldEnum.CEP_Transfer]: false,
                    }
              }
              onSubmit={this.handleInfoSubmit}
              studentSeedData={studentSeedData && studentSeedData.Result}
              languages={languages}
              grades={grades}
              isNew={isNewStudent}
              showDirtyLinkConfirm={this.props.showDirtyLinkConfirm}
              newServingNumber={this.props.newServingNumber}
              getNewServingNumber={() => this.props.getServingNumber()}
              clearServingNumber={() => this.props.clearServingNumber()}
              studentInfo={studentInfo}
              isReadOnly={isReadOnly}
              isCEPOrProvision2Site={isCEPOrProvision2Site}
              setStudentImage={(file) => {
                this.setState({
                  studentImage: file,
                  deleteImage: !Boolean(file),
                });
              }}
              pictureError={pictureError}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Contact Info',
        pane: (
          <Tab.Pane attached={false} key="contactInfo">
            <StudentContactInfo
              onSubmit={this.handleContactInfoSubmit}
              ref={(instance) => {
                this.studentContactInfoForm = instance;
              }}
              initialValues={
                studentSeedData && studentSeedData.Result
                  ? StudentContactInfoInitialValues(studentSeedData.Result)
                  : {}
              }
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Charge Permission',
        pane: (
          <Tab.Pane attached={false} key="chargePermission">
            <ChargePermission
              initialValues={chargePermissionInitialValues(studentSeedData)}
              isNewStudent={isNewStudent}
              onSubmit={this.handleChargePermissionSubmit}
              ref={(instance) => (this.chargePermissionForm = instance)}
              siteId={siteId}
            />
          </Tab.Pane>
        ),
      },
    ];

    return (
      <div>
        <Modal
          open={showEditModal}
          onClose={onClose}
          closeIcon
          size={'large'}
          closeOnRootNodeClick={false}
        >
          <Header
            content={
              isNewStudent
                ? 'Add New Student'
                : `Edit Student - ${
                    studentSeedData &&
                    studentSeedData.Result &&
                    studentSeedData.Result.FirstName
                  } ${
                    studentSeedData &&
                    studentSeedData.Result &&
                    studentSeedData.Result.LastName
                  }`
            }
            icon={isNewStudent ? 'plus' : 'signup'}
          />

          <Modal.Content className="p-t-0" scrolling>
            <ReactHeight
              onHeightReady={(height) => this.setContainerHeight(height)}
              style={{
                height: this.state.height !== 0 ? this.state.height + 'px' : '',
              }}
            >
              <Tab
                panes={panes}
                menu={{ secondary: true }}
                renderActiveOnly={false}
                activeIndex={this.props.selectedTab}
                onTabChange={this.onTabChange}
              />
            </ReactHeight>
          </Modal.Content>

          <Modal.Actions>{this.renderButton(isNewStudent)}</Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    languages: state.ImportStudentState.languages,
    grades: state.BasicSetupState.basicSetup.GetData,
    studentFilter: state.AccountSetupState.studentFilter,
    newServingNumber: state.AccountSetupState.servingNumber,
    rowIndex: state.AccountSetupState.rowIndex,
    saving: state.AccountSetupState.studentSaving,
    validStatusFieldChanged: state.AccountSetupState.validStatusFieldChanged,
    selectedTab: state.AccountSetupState.selectedTab,
    saveStudent: state.AccountSetupState.saveStudent,
    studentInfoLoading: state.AccountSetupState.studentInfoLoading,
    isDirty: getIsDirty()(state),
    showEditModal: state.AccountSetupState.showEditModal,
    isNewStudent: state.AccountSetupState.isNewStudent,
    formValues: getFormValues(ACCOUNT_SETUP_FORM_NAME)(state),
    pictureError: state.AccountSetupState.studentInfo.error,
    sitesData: getSites(state),
  };
};

export const StudentEditModal = connect(mapStateToProps, {
  clearServingNumber,
  getServingNumber,
  saveStudentInfoAction,
  getStudentInfoAction,
  setSelectedTab,
  getSitesAction,
  updateChargePermissions,
  resetDirty,
})(StudentEditModalContainer);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/StudentEditModal.js